export default __webpack_public_path__ + "static/media/icons8-user_rights.2a2819ee.svg";